import { configureStore } from '@reduxjs/toolkit';
import projectReducer from './project/projectSlice';
import brandReducer from './brand/brandSlice';
import uiReducer from './ui/uiSlice';
import { audiencesApi } from './api/audiencesApi';
import { brandsApi } from './api/brandsApi';
import { projectsApi } from './api/projectsApi';

export const store = configureStore({
  reducer: {
    project: projectReducer,
    brand: brandReducer,
    ui: uiReducer,
    [audiencesApi.reducerPath]: audiencesApi.reducer,
    [brandsApi.reducerPath]: brandsApi.reducer,
    [projectsApi.reducerPath]: projectsApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      audiencesApi.middleware,
      brandsApi.middleware,
      projectsApi.middleware,
    ),
});

